import { safeLs, safeSs } from 'shared/storages';

import type { ISamoletJwtAuthParams } from './types';

const JWT_AUTH_KEY = 'jwt_auth';

export const authStorage = {
  setJwtAuthParams(
    value: Partial<ISamoletJwtAuthParams>,
  ): Promise<Partial<ISamoletJwtAuthParams>> {
    return safeLs.add(JWT_AUTH_KEY, value);
  },
  getJwtAuthParams(): ISamoletJwtAuthParams | undefined {
    return safeLs.get<ISamoletJwtAuthParams, 'sync'>(JWT_AUTH_KEY, {
      parse: true,
      type: 'sync',
    });
  },
  cleanJwtAuthParams() {
    return safeLs.delete(JWT_AUTH_KEY, { returning: false });
  },
};

export const authInitStorage = {
  setJwtAuthParams(
    value: Partial<ISamoletJwtAuthParams>,
  ): Promise<Partial<ISamoletJwtAuthParams>> {
    return safeSs.add(JWT_AUTH_KEY, value);
  },
  getJwtAuthParams(): ISamoletJwtAuthParams | undefined {
    return safeSs.get<ISamoletJwtAuthParams, 'sync'>(JWT_AUTH_KEY, {
      parse: true,
      type: 'sync',
    });
  },
  cleanJwtAuthParams() {
    return safeSs.delete(JWT_AUTH_KEY, { returning: false });
  },
};
